import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

//Material-UI Core Components
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Typography from "@mui/material/Typography";

//Custom Components
import { GridContainer, GridItem } from "@/ui/Grid";
import FormContent from "@/components/FormContent";
import FormButton from "@/ui/Form/FormButton";
import useFormController from "@/components/useFormController";
import dataController from "@/lib/dataController";
import UserContext from "@/components/UserContext/UserContext";
import { IFieldsCollection } from "@/@types/models/model";
import api from "@/lib/api";

//Types

function AdminTasksForm() {
  const userContext = useContext(UserContext);

  const { t } = useTranslation();

  const useApi = new api();
  const [formData, setFormData] = useState({ "project_id": "", "path": "" })

  const handleSubmit = () => {
    const path = 'operations/admin/indexer/run_process'
    useApi.Call(path, "post", formData)
  };

  const fields: IFieldsCollection = [{
    type: "text",
    source: "path",
    title: "path",
    ttoken: "path",
  },
  {
    type: "numeric",
    source: "project_id",
    title: "project_id",
    ttoken: "project_id",
  }]

  const onFieldChange = (value: number | string, source: string) => {
    setFormData((prevState: any) => ({
      ...prevState,
      [source]: value
    }))
  }

  return (
    <Card>
      <CardContent>
        <GridContainer>
          <GridItem xs={12}>
            <Typography variant="h5" component="h3">
              {t("titles.admin_tasks")}
            </Typography>
          </GridItem>
          <FormContent
            fieldNames={["path", "project_id"]}
            record={formData}
            onSubmit={handleSubmit}
            onFieldChange={onFieldChange}
            mode={"insert"}
            columns={3}
            fields={fields} />
        </GridContainer>
      </CardContent>
      <CardActions>
        <FormButton variant="contained" onClick={handleSubmit}>
          {t("buttons.send")}
        </FormButton>
      </CardActions>
    </Card>
  );
}

export default AdminTasksForm;
